module.exports = __webpack_public_path__ + "img/kx5600-char-1.2817c6cd.png";